import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '@/logic/break/BreakUtils';

registerCollisionAnimation('MATRIX_RAIN', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  for (let i = 0; i < 15; i++) {
    const rnd = seedRandom(e.id, i);
    const x = e.pos.x + (rnd - 0.5) * 60;
    const y = e.pos.y + progress * 100 * (0.5 + rnd);
    ctx.fillStyle = determineColor(i, 15);
    ctx.globalAlpha = 1 - progress;
    ctx.font = "10px monospace";
    ctx.fillText(String.fromCharCode(0x30A0 + Math.floor(rnd * 96)), x, y);
  }
});
